import { useState } from "react";
import { Box } from "@mui/material";
import CustomDataGrid from "../../../../ui library/components/data-grid/CustomDataGrid";
import Colors from "../../../../global/Colors";
import { Folder } from "@mui/icons-material";
import { useRevalidator } from "react-router-dom";
import { useDocumentListStore } from "../hooks/useDocumentListStore";

export default function FolderList({ folders, setCurrentFolder }) {
  const { setFolderId } = useDocumentListStore();
  const { revalidate } = useRevalidator();
  const [activeRowId, setActiveRowId] = useState(null);

  const columns = [
    {
      field: "folderName",
      headerName: "Name",
      minWidth: 175,
      flex: 1.5,
      align: "left",
      headerAlign: "left",
      sortable: false,
      filterable: false,
      renderCell: ({ row }) => (
        <Box className="flex w-full items-center p-0">
          <div className="flex justify-center items-center h-full">
            <Folder className="text-gray-500 mx-2" />
            <span>{row.folder_name}</span>
          </div>
        </Box>
      ),
    },
    {
      field: "documentCount",
      headerName: "Document Count",
      minWidth: 175,
      flex: 1.5,
      align: "left",
      headerAlign: "left",
      sortable: false,
      filterable: false,
      renderCell: ({ row }) => (
        <Box className="flex w-full justify-start px-3">
          <span>{row.folder_count}</span>
        </Box>
      ),
    },
  ];

  function getRowId(row) {
    return row.folder_id;
  }

  const onHandleClick = (row) => {
    if (row.folder_count > 0) {
      setFolderId(row.folder_id);
      revalidate();
    }
  };

  return (
    <Box className="w-full h-fit overflow-y-auto p-4 pb-0 flex items-center justify-center">
      <CustomDataGrid
        columns={columns}
        getRowId={getRowId}
        disableRowSelectionOnClick
        disableMultipleRowSelection
        getRowHeight={() => "160"}
        getEstimatedRowHeight={() => "100"}
        rowSelection={false}
        rows={folders ?? []}
        onRowClick={(params) => {
          if (params.row.folder_count > 0) {
            setActiveRowId(params.id);
            onHandleClick(params.row);
            setCurrentFolder(params.row['folder_name'])
          }
        }}
        getRowClassName={(params) => {
          let base = params.row.folder_count === 0 ? "disabled" : "";
          if (params.id === activeRowId) {
            base += " active-row";
          }
          return base;
        }}
        sx={{
          "& .MuiDataGrid-cell": {
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            padding: "0 0",
            borderBottom: `1px solid ${Colors.gray[100]}`,
            overflow: "visible",
            boxSizing: "border-box",
          },
          "& .MuiDataGrid-row": {
            cursor: "pointer",
          },
          "& .MuiDataGrid-row.disabled": {
            pointerEvents: "none",
            cursor: "default",
          },
          "& .MuiDataGrid-row.active-row": {
            backgroundColor: Colors.gray[200],
          },
        }}
      />
    </Box>
  );
}
